import { openLink } from '@telegram-apps/sdk-react';

export const openExternalLink = (url: string): void => {
  if (openLink.isAvailable()) {
    openLink(url);

    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
};
